var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"pill":"","title":_vm.tooltip,"variant":"success"}},[_vm._v(" PMS "),_c('i',{staticClass:"fas fa-info-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }